import { render, staticRenderFns } from "./DialogNoticeNews.vue?vue&type=template&id=4573e190&scoped=true&"
import script from "./DialogNoticeNews.vue?vue&type=script&lang=js&"
export * from "./DialogNoticeNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573e190",
  null
  
)

export default component.exports